import { jsx } from "react/jsx-runtime";
import {
  createContext,
  useContext,
  useEffect,
  useEffectEvent,
  useMemo,
  useState
} from "react";
import { ShortcutRegistry } from "./registry.js";
const RegistryContext = createContext(null);
function ShortcutProvider({ registry, target, children }) {
  const value = useMemo(() => registry ?? new ShortcutRegistry(), [registry]);
  useEffect(() => {
    const element = target ?? document;
    const onKeyDown = (event) => {
      value.handleKeyDown(event);
    };
    element.addEventListener("keydown", onKeyDown);
    return () => {
      element.removeEventListener("keydown", onKeyDown);
    };
  }, [value, target]);
  return /* @__PURE__ */ jsx(RegistryContext.Provider, { value, children });
}
function useShortcutRegistry() {
  const registry = useContext(RegistryContext);
  if (!registry) throw new Error("useShortcut needs a <ShortcutProvider>");
  return registry;
}
function useShortcut(definition, handler, enabled = true) {
  const registry = useShortcutRegistry();
  const onTrigger = useEffectEvent(handler);
  useEffect(() => {
    if (!enabled) return void 0;
    return registry.register(definition, () => {
      onTrigger();
    });
  }, [registry, definition, enabled]);
}
function useShortcutList() {
  const registry = useShortcutRegistry();
  const [snapshot, setSnapshot] = useState(() => ({
    shortcuts: registry.list(),
    enabled: registry.isEnabled
  }));
  useEffect(
    () => registry.subscribe(() => {
      setSnapshot({ shortcuts: registry.list(), enabled: registry.isEnabled });
    }),
    [registry]
  );
  return snapshot;
}
export {
  ShortcutProvider,
  useShortcut,
  useShortcutList,
  useShortcutRegistry
};
//# sourceMappingURL=react.js.map